import styled from '@emotion/styled';
import { Button, ButtonProps, Icon, pxToRem } from '@lbcamden/lib-react';
import { ReactNode, Ref } from 'react';

type Props = Omit<Partial<ButtonProps>, 'children'> & {
  label?: ReactNode;
  ref?: Ref<HTMLButtonElement>;
};

const ButtonBase = ({ ref, label = 'Add new', ...props }: Props) => (
  <Button ref={ref} $variant="tertiary" $color="primary" {...props}>
    <Icon icon="ui/plus" />
    {label}
  </Button>
);

export const AddNewButton = styled(ButtonBase)`
  position: relative;
  flex-shrink: 0;
  margin-left: auto;

  &:hover:not(:disabled) {
    color: ${({ theme }) => theme.colors.primaryHover};
  }

  svg {
    width: ${pxToRem(12)};
  }
`;
